// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");

var AccountInfo = {};

var GetAuthToken = {};

function getAuthToken(throwIfNotGrantedOrRevoked, interactive, account, scopes, param) {
  return new Promise((function (resolve, reject) {
                chrome.identity.getAuthToken({
                      interactive: interactive,
                      account: account,
                      scopes: scopes
                    }, (function (authToken) {
                        var jsExn = browser.runtime.lastError;
                        if (jsExn == null) {
                          return resolve(authToken);
                        }
                        var msg = jsExn.message;
                        if (msg !== undefined && !throwIfNotGrantedOrRevoked && msg.includes("OAuth2 not granted or revoked.")) {
                          return resolve(undefined);
                        }
                        return reject(Js_exn.raiseError(OptionUtils$SmartcutsMacros.withDefault("", jsExn.message)));
                      }));
                
              }));
}

var RemoveCachedAuthToken = {};

function removeCachedAuthToken(token) {
  return new Promise((function (resolve, param) {
                chrome.identity.removeCachedAuthToken({
                      token: token
                    }, (function (param) {
                        var jsExn = browser.runtime.lastError;
                        if (jsExn == null) {
                          return resolve({
                                      TAG: /* Ok */0,
                                      _0: undefined
                                    });
                        } else {
                          return resolve({
                                      TAG: /* Error */1,
                                      _0: jsExn
                                    });
                        }
                      }));
                
              }));
}

var LaunchWebAuthFlow = {};

function launchWebAuthFlow(interactive, url, param) {
  return browser.identity.launchWebAuthFlow({
              url: url,
              interactive: interactive
            });
}

exports.AccountInfo = AccountInfo;
exports.GetAuthToken = GetAuthToken;
exports.getAuthToken = getAuthToken;
exports.RemoveCachedAuthToken = RemoveCachedAuthToken;
exports.removeCachedAuthToken = removeCachedAuthToken;
exports.LaunchWebAuthFlow = LaunchWebAuthFlow;
exports.launchWebAuthFlow = launchWebAuthFlow;
/* No side effect */
